export default __webpack_public_path__ + "static/media/throatslash.8fc8caf9.png";